import { api } from "./api";

const actions = {
	deleteTheme: (code, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "DELETE",
					url: `/api/v1/theme/${code}`,
					onSuccess,
					onFailure
				})
			);
		};
	},
	getTreeTheme: (code, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/theme/tree/${code}`,
					onSuccess,
					onFailure
				})
			);
		};
	},
	insertTreeFromJSON: (data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/theme/json`,
					data,
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Train questions */
	startQuestionsTraining: (
		language,
		questionsToTranslate,
		questionsToTrain,
		theme,
		answerItem,
		onSuccess,
		onFailure = () => {}
	) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/theme/questions/train`,
					data: {
						language,
						questionsToTranslate,
						questionsToTrain,
						theme,
						answerItem
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Untrain questions */
	startQuestionsUntraining: (codes, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/theme/questions/untrain`,
					data: {
						codes
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Train all questions from a category */
	startCategoryTraining: ({ codes, type, messageID }, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/theme/category/train`,
					data: {
						codes,
						type,
						messageID
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Untrain all questions from a category */
	startCategoryUntraining: (codes, type, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/theme/category/untrain`,
					data: {
						codes,
						type
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Generate answer */
	generateAnswers: (codes, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/theme/generate/answers`,
					data: {
						codes
					},
					onSuccess,
					onFailure
				})
			);
		};
	}
};

export default actions;
